import moment from "moment";
import { NO_DATE } from "../common/constants";

export const getFormattedDate = (date: string, format: string = "DD MMMM, YYYY", noDataValue: string = ""): string => !date || date === NO_DATE ? noDataValue : moment(date).format(format);
export const getTableFormattedDate = (date: string): string => getFormattedDate(date, "M/D/YYYY", "-");

export const getExternalDate = (date: string | null = null): string => date ? new Date(date).toISOString() : '';
export const getInternalDate = (date: string): string => getFormattedDate(date, 'yyyy-MM-DD');
